/**
 *  Salon Premium — product page description "Read more"
 *  The product description is shown up to 600 characters (spaces included), cut at the
 *  nearest whole word and followed, on the same line, by "… Pročitaj više". When opened,
 *  "Prikaži manje" follows the last sentence of the full text. Formatting (headings, bold,
 *  lists) is kept, and the full text stays in the page for SEO.
 *  Loaded from snippets/head-preload.liquid on product templates.
 */
(function () {
  var LIMIT = 600;       // characters, spaces included
  var MIN_REST = 80;     // don't collapse if fewer than this many characters would be hidden

  var lang = (document.documentElement.lang || '').toLowerCase();
  var TEXT = lang.indexOf('hr') === 0 ? { more: 'Pročitaj više', less: 'Prikaži manje' }
    : lang.indexOf('sl') === 0 ? { more: 'Preberi več', less: 'Prikaži manj' }
    : { more: 'Read more', less: 'Read less' };

  var INLINE_HOSTS = /^(P|LI|SPAN|STRONG|B|EM|I|A|H1|H2|H3|H4|H5|H6|BLOCKQUOTE|TD|DD|DT|FIGCAPTION|DIV)$/;

  function visibleLength(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim().length;
  }

  // Cut a node tree after LIMIT visible characters, at a word boundary.
  // Returns the text node that now ends with "…", or null.
  function truncate(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var count = 0, node, cutNode = null, cutIndex = 0, prevSpace = true;

    while ((node = walker.nextNode())) {
      var t = node.nodeValue;
      if (!t.trim()) continue;
      for (var i = 0; i < t.length; i++) {
        var isSpace = /\s/.test(t[i]);
        if (isSpace && prevSpace) continue;
        prevSpace = isSpace;
        count++;
        if (count >= LIMIT) { cutNode = node; cutIndex = i + 1; break; }
      }
      if (cutNode) break;
    }
    if (!cutNode) return null;

    var text = cutNode.nodeValue;
    // Mid-word? Go back to the previous space, or forward to the next one.
    if (cutIndex < text.length && /\S/.test(text[cutIndex]) && /\S/.test(text[cutIndex - 1])) {
      var back = text.slice(0, cutIndex).search(/\s\S*$/);
      if (back > 0) {
        cutIndex = back;
      } else {
        var fwd = text.slice(cutIndex).search(/\s/);
        cutIndex = fwd === -1 ? text.length : cutIndex + fwd;
      }
    }
    cutNode.nodeValue = text.slice(0, cutIndex).replace(/[\s,;:–—-]+$/, '') + '…';

    // Remove everything after the cut point.
    var current = cutNode;
    while (current && current !== root) {
      while (current.nextSibling) current.parentNode.removeChild(current.nextSibling);
      current = current.parentNode;
    }
    return cutNode;
  }

  // The last text node with visible text inside root.
  function lastTextNode(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node, last = null;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim()) last = node;
    }
    return last;
  }

  // Put the button right after a text node, on the same line. Inside links or
  // bold text it goes after that element so it doesn't inherit its styling/link.
  function placeAfter(textNode, button, fallbackParent) {
    if (!textNode) {
      fallbackParent.appendChild(button);
      return;
    }
    var anchor = textNode;
    while (anchor.parentNode && /^(A|STRONG|B|EM|I|SPAN|U|SMALL)$/.test(anchor.parentNode.nodeName)) {
      anchor = anchor.parentNode;
    }
    var host = anchor.parentNode;
    if (!host || !INLINE_HOSTS.test(host.nodeName) && host !== fallbackParent) {
      fallbackParent.appendChild(button);
      return;
    }
    host.insertBefore(document.createTextNode(' '), anchor.nextSibling);
    host.insertBefore(button, anchor.nextSibling.nextSibling);
  }

  function makeButton(label, expanded) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'text-button sp-desc__toggle';
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = label;
    return button;
  }

  function setup(el) {
    if (el.dataset.spReadMore) return;
    if (visibleLength(el) < LIMIT + MIN_REST) return;

    var full = document.createElement('div');
    full.className = 'sp-desc__full';
    while (el.firstChild) full.appendChild(el.firstChild);

    var short = document.createElement('div');
    short.className = 'sp-desc__short';
    for (var i = 0; i < full.childNodes.length; i++) short.appendChild(full.childNodes[i].cloneNode(true));

    var cutNode = truncate(short);
    if (!cutNode) {
      while (full.firstChild) el.appendChild(full.firstChild);
      return;
    }
    el.dataset.spReadMore = 'true';
    short.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });

    var moreButton = makeButton(TEXT.more, false);
    var lessButton = makeButton(TEXT.less, true);
    placeAfter(cutNode, moreButton, short);
    placeAfter(lastTextNode(full), lessButton, full);

    full.hidden = true;
    el.appendChild(short);
    el.appendChild(full);

    moreButton.addEventListener('click', function () {
      short.hidden = true;
      full.hidden = false;
      lessButton.focus({ preventScroll: true });
    });
    lessButton.addEventListener('click', function () {
      full.hidden = true;
      short.hidden = false;
      moreButton.focus({ preventScroll: true });
      var top = el.getBoundingClientRect().top;
      if (top < 0) window.scrollBy({ top: top - 120, behavior: 'smooth' });
    });

    // If the theme's own height limit wraps the description, switch it off.
    var maxHeight = el.closest('max-height');
    if (maxHeight) {
      maxHeight.style.setProperty('--max-height', 'none');
      var themeToggle = maxHeight.querySelector('.max-height--toggle');
      if (themeToggle) themeToggle.hidden = true;
    }
  }

  function init() {
    document.querySelectorAll('.thb-product-detail:not(.thb-product-detail--quick-view) .product-short-description').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor: re-run when the product section is reloaded.
  document.addEventListener('shopify:section:load', init);
})();
